<template>
  <coverage-page
    :customPageControl="pageControl"
    :customDefaultForm="defaultForm"
    :customNeedValidate="needValidate"
  />
</template>
<script>
import { mapGetters } from "vuex";
import CoveragePage from "./components/CoveragePage.vue";
import { commonMixin } from "@/mixins/common";
export default {
  mixins: [commonMixin],
  name: "AccidentalMedical",
  components: {
    CoveragePage,
  },
  data() {
    return {
      pageControl: {
        pageName: "意外保障",
        coverageParentCategories: ["意外身故", "意外醫療", "燒燙傷保險金"],
        pageBlock: ["period", "formula", "maxCustom"],
        showUpper: true,
      },
      defaultForm: {
        unit_lower: 3,
      },
      needValidate: {
        period_upper: false,
      },
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
